import { render, staticRenderFns } from "./SmartManageCourse.vue?vue&type=template&id=4f95d694&scoped=true&"
import script from "./SmartManageCourse.vue?vue&type=script&lang=js&"
export * from "./SmartManageCourse.vue?vue&type=script&lang=js&"
import style0 from "./SmartManageCourse.vue?vue&type=style&index=0&id=4f95d694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f95d694",
  null
  
)

export default component.exports